import pxToEm from '@shared/components/mixins/shared/pxToEm'
import genericContentItem from '@shared/components/mixins/genericContentItem'

export default {
  name: 'TextComponent',
  mixins: [genericContentItem, pxToEm],
}
